<div class="min-vh-100 d-flex flex-column">
  <app-header></app-header>

  <div class="flex-grow-1">
    <div class="container-fluid">
      <div class="row">

        <app-sidebar class="col-12 col-md-3 col-lg-2 border-end bg-body-tertiary p-0"></app-sidebar>

        <main class="col-12 col-md-9 col-lg-10 p-3 p-md-4 pm-main">
          <router-outlet></router-outlet>
        </main>

      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
